import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useCurrentNamespace } from '@modules/permissions/composables';
import {
  POSTBACKS_LIST_QUERY_KEY,
  POSTBACKS_PERMISSIONS,
} from '@modules/postbacks/constants';

import type {
  IPostbackWebhook,
  IPostbackWebhookSaveResponse,
} from '../types';
import {
  ADMIN_POSTBACKS_SAVE_URL,
  AFFILIATE_POSTBACKS_SAVE_URL,
  POSTBACKS_SAVE_MUTATION_KEY,
} from '../constants';

export default function usePostbackWebhookSaveMutation(): IContextMutationResult<
  IPostbackWebhookSaveResponse,
  Error,
  IPostbackWebhook
> {
  const { fetchPut } = useRestClient();
  const { isAdminNamespace } = useCurrentNamespace();

  return useContextMutation<IPostbackWebhookSaveResponse, Error, IPostbackWebhook>({
    mutationKey: [POSTBACKS_SAVE_MUTATION_KEY],
    mutationFn: ({ affiliateId, ...webhook }) => fetchPut<IPostbackWebhookSaveResponse>(
      isAdminNamespace.value ? ADMIN_POSTBACKS_SAVE_URL : AFFILIATE_POSTBACKS_SAVE_URL,
      {
        webhook,
      },
      {
        permission: POSTBACKS_PERMISSIONS.SHOW,
        urlParams: {
          id: affiliateId,
          postbackId: webhook.id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [POSTBACKS_LIST_QUERY_KEY] });
    },
  });
}
